import { useEffect, useState } from 'react';
import { SESSION_STATE_PREFIX } from '../constants/sessionState';

/**
 * useState mirrored in sessionStorage: the value survives a refresh of this tab,
 * dies with the tab. null removes the entry. Values must be JSON-serialisable.
 */
const storageKey = (key) => `${SESSION_STATE_PREFIX}${key}`;

const read = (key, initial) => {
  try {
    const raw = sessionStorage.getItem(storageKey(key));
    return raw === null ? initial : JSON.parse(raw);
  } catch {
    return initial;
  }
};

export default function useSessionState(key, initial = null) {
  const [value, setValue] = useState(() => read(key, initial));

  useEffect(() => {
    try {
      if (value === null || value === undefined) sessionStorage.removeItem(storageKey(key));
      else sessionStorage.setItem(storageKey(key), JSON.stringify(value));
    } catch { /* Private mode or quota: in-memory state still works. */ }
  }, [key, value]);

  return [value, setValue];
}

/** Drops every persisted selection (logout, account switch). */
export function clearSessionState() {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(SESSION_STATE_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch { /* Storage unavailable: nothing persisted. */ }
}
